import FormContent from "./FormContent";
import "./SignUpForm.css";

const SignUpForm = () => {
  return (
    <div className="sign-up">
      <FormContent />
      <div className="img"></div>
    </div>
  );
};

export default SignUpForm;
